/* eslint-disable */
import JSTool from './JSTool.js';
import { setStorage, getStorageSync } from '@fund/storage';
import {
  setCommonStorageSync,
} from '../utils/nativeBridge';

class Util {
  constructor() { }

  periodMap() {
    return {
      Z: '近1周',
      Y: '近1月',
      '3Y': '近3月',
      '6Y': '近6月',
      '1N': '近1年',
      '2N': '近2年',
      '3N': '近3年',
      '5N': '近5年',
      JN: '近xx年',
      LN: '近xxx年',
    };
  }

  // 个位数补零
  prefixZero(num) {
    let newNum = 0;
    if (JSTool.isNumber(num)) {
      newNum = num;
    } else if (JSTool.isString(num)) {
      newNum = parseInt(num);
    } else {
      return num;
    }
    if (newNum >= 10 || newNum <= -10) {
      return `${newNum}`;
    }
    return `${newNum >= 0 ? '' : '-'}0${newNum}`;
  }

  // 时间处理
  // 2019-12-23 10:14:00
  dateFromString(timeStr) {
    if (!JSTool.isString(timeStr) || !timeStr) return null

    let newTimeStr = timeStr;
    if (newTimeStr.indexOf('T') != -1) {
      newTimeStr = newTimeStr.replace(new RegExp("T", "g"), " ")
    }
    if (newTimeStr.length > 19) {
      newTimeStr = newTimeStr.substring(0, 19)
    }

    var timeArr = newTimeStr.split(" ")
    var d = timeArr[0].split("-")
    var t = timeArr[1].split(":")
    var date = new Date(d[0], d[1] - 1, d[2], t[0], t[1], t[2])
    if(!t[2]){
      date = new Date(d[0], d[1] - 1, d[2], t[0], t[1], '00');
    }
    return date
    //     var year = date.getFullYear();//年
    // 　　var month = date.getMonth();//月
    // 　　var day = date.getDate();//日
    // 　　var hours = date.getHours();//时
    // 　　var min = date.getMinutes();//分
    // 　　var second = date.getSeconds();//秒

  }

  formatTimeString(timeString) {
    //发布时间
    //当天 1h内显示[x分钟前],超出1h显示[x小时前]
    //昨天/前天 显示[昨天/前天 23:59]
    //当年 非上述三天 显示[06-12 23:59]
    //非本年 显示[2019-06-12 23:59]

    //显示日期
    // 加点兼容方法
    if (!timeString) {
      return '';
    }
    if (!timeString.replace) {
      return '';
    }
    const date = this.dateFromString(timeString);
    if (!date) return ''
    let resTime = ''
    var year = date.getFullYear();//年
    var month = date.getMonth() + 1;//月    
    var day = date.getDate();//日
    var hours = date.getHours();//时    
    var min = date.getMinutes();//分
    var time = date.getTime();

    //当前日期
    const cDate = new Date();
    var cYear = cDate.getFullYear();
    var cMonth = cDate.getMonth() + 1;
    var cDay = cDate.getDate();
    var cMin = cDate.getMinutes();
    var cTime = cDate.getTime();
    const today = `${cYear}/${this.prefixZero(cMonth)}/${this.prefixZero(cDay)}`;
    const todayTime = new Date(today).getTime();

    //毫秒差
    const num = cTime - time;
    const Zero = (num) => {
      return this.prefixZero(num)
    }
    
    var minGap = num / (1000 * 60);
    var hourGap = minGap / 60;
    var dayGap = hourGap / 24;

    const twentyFourHours = 24 * 60 * 60 *1000;
    const fortyEightHours = 24 * 60 * 60 *1000 * 2;
    const yesterdayTime = new Date(todayTime - twentyFourHours).getTime();
    const lastYesterdayTime = new Date(todayTime - fortyEightHours).getTime();
    // console.log('dayGap '+dayGap+' minGap  '+minGap +' hourGap  '+hourGap);
    if (cYear > year || num < 0) {
      resTime = `${year}-${Zero(month)}-${Zero(day)} ${Zero(hours)}:${Zero(min)}`
    } else if (time < lastYesterdayTime) {
      resTime = `${Zero(month)}-${Zero(day)} ${Zero(hours)}:${Zero(min)}`
    } else {
      if (time < yesterdayTime && lastYesterdayTime <= time) {
        resTime = `${Zero(month)}-${Zero(day)} ${Zero(hours)}:${Zero(min)}`
      } else if (time < todayTime && yesterdayTime <= time) {
        resTime = `昨天 ${Zero(hours)}:${Zero(min)}`
      } else {
        if (hourGap >= 1) {
          resTime = Math.floor(hourGap).toString() + "小时前";
        } else if (minGap.toFixed(0) <= 1) {
          resTime = "刚刚";
        } else {// >1  >0
          resTime = Math.floor(minGap).toString() + "分钟前";
        }
      }
    }
    if(num < 0){
      resTime = "刚刚";
    }
    return resTime;
  }

  setCache(key, value) {
    setStorage(key, value);
    window.localStorage.setItem(key, value);
    setCommonStorageSync({
      key,
      data: value,
    });
  }

  getCache(key) {
    const fv = getStorageSync(key);
    if (fv) {
      return fv;
    }
///////////////////////////////////
////////////////////////////////////////
//////////////////////////////////////////
//////////////////////////////////////////
/////////////////////////////////////////////////////
///////////////
/////
/////////////
    return window.localStorage.getItem(key);
  }

  setTipGuideCache(key, value) {
    setStorage(key, value);
    setCommonStorageSync({
      key,
      data: value,
    });
    window.localStorage.setItem(key, value);
  }

  getTipGuideCache(key) {
    const fv = getStorageSync(key);
    if (fv) {
      return fv;
    }
///////////////////////////////////
////////////////////////////////////////
//////////////////////////////////////////
//////////////////////////////////////////
/////////////////////////////////////////////////////
//////////////
/////////////////
///////
/////
/////////////
    return window.localStorage.getItem(key);
  }

  debounce(fn, wait = 200) { // 防止抖动
    // 通过闭包缓存一个定时器 id
    let timer = null;
    // 将 debounce 处理结果当作函数返回
    // 触发事件回调时执行这个返回函数
    return function (...args) {
      // 如果已经设定过定时器就清空上一次的定时器
      if (timer) clearTimeout(timer);
      // 开始设定一个新的定时器，定时器结束后执行传入的函数 fn
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, wait);
    };
  }

  // isEmpty
  isEmpty(item) {
    return item === '-' || item === '--' || item === '' || item === null || !item;
  }

  getemojiList() {
    const emojiList = [
      {
        value: '[微笑]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot01.png',
      },
      {
        value: '[大笑]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot02.png',
      },
      {
        value: '[鼓掌]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot03.png',
      },
      {
        value: '[为什么]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot04.png',
      },
      {
        value: '[哭]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot05.png',
      },
      {
        value: '[怒]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot06.png',
      },
      {
        value: '[滴汗]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot07.png',
      },
      {
        value: '[俏皮]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot08.png',
      },
      {
        value: '[傲]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot09.png',
      },
      {
        value: '[好困惑]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot10.png',
      },
      {
        value: '[兴奋]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot11.png',
      },
      {
        value: '[加油]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot12.png',
      },
      {
        value: '[困顿]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot13.png',
      },
      {
        value: '[想一下]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot14.png',
      },
      {
        value: '[撇嘴]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot15.png',
      },
      {
        value: '[色]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot16.png',
      },
      {
        value: '[发呆]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot17.png',
      },
      {
        value: '[得意]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot18.png',
      },
      {
        value: '[害羞羞]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot19.png',
      },
      {
        value: '[大哭]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot20.png',
      },
      {
        value: '[呲牙]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot21.png',
      },
      {
        value: '[惊讶]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot22.png',
      },
      {
        value: '[囧]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot23.png',
      },
      {
        value: '[抓狂]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot24.png',
      },
      {
        value: '[偷笑]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot25.png',
      },
      {
        value: '[愉快]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot26.png',
      },
      {
        value: '[憨笑]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot27.png',
      },
      {
        value: '[晕]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot28.png',
      },
      {
        value: '[再见]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot29.png',
      },
      {
        value: '[坏笑]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot30.png',
      },
      {
        value: '[左哼哼]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot31.png',
      },
      {
        value: '[右哼哼]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot32.png',
      },
      {
        value: '[哈欠]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot33.png',
      },
      {
        value: '[委屈]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot34.png',
      },
      {
        value: '[快哭了]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot35.png',
      },
      {
        value: '[亲]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot36.png',
      },
      {
        value: '[可怜]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot37.png',
      },
      {
        value: '[口罩]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot38.png',
      },
      {
        value: '[笑哭]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot39.png',
      },
      {
        value: '[惊吓]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot40.png',
      },
      {
        value: '[哼]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot41.png',
      },
      {
        value: '[捂脸]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot42.png',
      },
      {
        value: '[奸笑]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot43.png',
      },
      {
        value: '[吃瓜]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot44.png',
      },
      {
        value: '[旺柴]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot45.png',
      },
      {
        value: '[围观]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot46.png',
      },
      {
        value: '[摊手]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot47.png',
      },
      {
        value: '[爱心]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot48.png',
      },
      {
        value: '[献花]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot49.png',
      },
      {
        value: '[福]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot50.png',
      },
      {
        value: '[拜神]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot51.png',
      },
      {
        value: '[胜利]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot52.png',
      },
      {
        value: '[赞]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot53.png',
      },
      {
        value: '[握手]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot54.png',
      },
      {
        value: '[抱拳]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot55.png',
      },
      {
        value: '[勾引]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot56.png',
      },
      {
        value: '[拳头]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot57.png',
      },
      {
        value: '[OKOK]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot58.png',
      },
      {
        value: '[强壮]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot59.png',
      },
      {
        value: '[毛估估]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot60.png',
      },
      {
        value: '[亏大了]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot61.png',
      },
      {
        value: '[赚大了]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot62.png',
      },
      {
        value: '[牛]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot63.png',
      },
      {
        value: '[成交]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot65.png',
      },
      {
        value: '[财力]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot66.png',
      },
      {
        value: '[护城河]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot67.png',
      },
      {
        value: '[复盘]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot68.png',
      },
      {
        value: '[买入]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot69.png',
      },
      {
        value: '[卖出]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot70.png',
      },
      {
        value: '[满仓]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot71.png',
      },
      {
        value: '[空仓]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot72.png',
      },
      {
        value: '[抄底]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot73.png',
      },
      {
        value: '[看多]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot74.png',
      },
      {
        value: '[看空]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot75.png',
      },
      {
        value: '[加仓]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot76.png',
      },
      {
        value: '[减仓]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot77.png',
      },
      {
        value: '[上涨]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot78.png',
      },
      {
        value: '[下跌]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot79.png',
      },
      {
        value: '[财神]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot80.png',
      },
      {
        value: '[火箭]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot81.png',
      },
      {
        value: '[龙头]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot82.png',
      },
      {
        value: '[韭菜]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot83.png',
      },
      {
        value: '[面]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot84.png',
      },
      {
        value: '[泡沫]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot85.png',
      },
      {
        value: '[惨!关灯吃面]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot86.png',
      },
      {
        value: '[666]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot87.png',
      },
      {
        value: '[叹气]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot88.png',
      },
      {
        value: '[让我看看]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot89.png',
      },
      {
        value: '[发财]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot90.png',
      },
      {
        value: '[主力]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot91.png',
      },
      {
        value: '[梭哈]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot92.png',
      },
      {
        value: '[国家队]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot93.png',
      },
      {
        value: '[中签]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot94.png',
      },
      {
        value: '[干杯]',
        src: 'https://j5.dfcfw.com/imagesystem/emoji/emot95.png',
      },
    ];
    return emojiList;
  }

  // 表情
  handleEmoji(str) {
    let srcMatched = '';
    const emojiList = this.getemojiList();
    emojiList.forEach((item) => {
      if (str === item.value) {
        srcMatched = item.src;
      }
    });
    return srcMatched;
  }

  getKey(val, object) {
    let data;
    const keys = Object.keys(object);
    const values = Object.keys(object).map((key) => object[key]);
    for (let index = 0; index < values.length; index += 1) {
      if (val === values[index]) {
        data = keys[index];
        break;
      }
    }
    return data;
  }

  emojiName(list) {
    const emojiList = {
      'https://j5.dfcfw.com/imagesystem/emoji/emot01.png': '微笑',
      'https://j5.dfcfw.com/imagesystem/emoji/emot02.png': '大笑',
      'https://j5.dfcfw.com/imagesystem/emoji/emot03.png': '鼓掌',
      'https://j5.dfcfw.com/imagesystem/emoji/emot04.png': '为什么',
      'https://j5.dfcfw.com/imagesystem/emoji/emot05.png': '哭',
      'https://j5.dfcfw.com/imagesystem/emoji/emot06.png': '怒',
      'https://j5.dfcfw.com/imagesystem/emoji/emot07.png': '滴汗',
      'https://j5.dfcfw.com/imagesystem/emoji/emot08.png': '俏皮',
      'https://j5.dfcfw.com/imagesystem/emoji/emot09.png': '傲',
      'https://j5.dfcfw.com/imagesystem/emoji/emot10.png': '好困惑',
      'https://j5.dfcfw.com/imagesystem/emoji/emot11.png': '兴奋',
      'https://j5.dfcfw.com/imagesystem/emoji/emot12.png': '加油',
      'https://j5.dfcfw.com/imagesystem/emoji/emot13.png': '困顿',
      'https://j5.dfcfw.com/imagesystem/emoji/emot14.png': '想一下',
      'https://j5.dfcfw.com/imagesystem/emoji/emot15.png': '撇嘴',
      'https://j5.dfcfw.com/imagesystem/emoji/emot16.png': '色',
      'https://j5.dfcfw.com/imagesystem/emoji/emot17.png': '发呆',
      'https://j5.dfcfw.com/imagesystem/emoji/emot18.png': '得意',
      'https://j5.dfcfw.com/imagesystem/emoji/emot19.png': '害羞羞',
      'https://j5.dfcfw.com/imagesystem/emoji/emot20.png': '大哭',
      'https://j5.dfcfw.com/imagesystem/emoji/emot21.png': '呲牙',
      'https://j5.dfcfw.com/imagesystem/emoji/emot22.png': '惊讶',
      'https://j5.dfcfw.com/imagesystem/emoji/emot23.png': '囧',
      'https://j5.dfcfw.com/imagesystem/emoji/emot24.png': '抓狂',
      'https://j5.dfcfw.com/imagesystem/emoji/emot25.png': '偷笑',
      'https://j5.dfcfw.com/imagesystem/emoji/emot26.png': '愉快',
      'https://j5.dfcfw.com/imagesystem/emoji/emot27.png': '憨笑',
      'https://j5.dfcfw.com/imagesystem/emoji/emot28.png': '晕',
      'https://j5.dfcfw.com/imagesystem/emoji/emot29.png': '再见',
      'https://j5.dfcfw.com/imagesystem/emoji/emot30.png': '坏笑',
      'https://j5.dfcfw.com/imagesystem/emoji/emot31.png': '左哼哼',
      'https://j5.dfcfw.com/imagesystem/emoji/emot32.png': '右哼哼',
      'https://j5.dfcfw.com/imagesystem/emoji/emot33.png': '哈欠',
      'https://j5.dfcfw.com/imagesystem/emoji/emot34.png': '委屈',
      'https://j5.dfcfw.com/imagesystem/emoji/emot35.png': '快哭了',
      'https://j5.dfcfw.com/imagesystem/emoji/emot36.png': '亲',
      'https://j5.dfcfw.com/imagesystem/emoji/emot37.png': '可怜',
      'https://j5.dfcfw.com/imagesystem/emoji/emot38.png': '口罩',
      'https://j5.dfcfw.com/imagesystem/emoji/emot39.png': '笑哭',
      'https://j5.dfcfw.com/imagesystem/emoji/emot40.png': '惊吓',
      'https://j5.dfcfw.com/imagesystem/emoji/emot41.png': '哼',
      'https://j5.dfcfw.com/imagesystem/emoji/emot42.png': '捂脸',
      'https://j5.dfcfw.com/imagesystem/emoji/emot43.png': '奸笑',
      'https://j5.dfcfw.com/imagesystem/emoji/emot44.png': '吃瓜',
      'https://j5.dfcfw.com/imagesystem/emoji/emot45.png': '旺柴',
      'https://j5.dfcfw.com/imagesystem/emoji/emot46.png': '围观',
      'https://j5.dfcfw.com/imagesystem/emoji/emot47.png': '摊手',
      'https://j5.dfcfw.com/imagesystem/emoji/emot48.png': '爱心',
      'https://j5.dfcfw.com/imagesystem/emoji/emot49.png': '献花',
      'https://j5.dfcfw.com/imagesystem/emoji/emot50.png': '福',
      'https://j5.dfcfw.com/imagesystem/emoji/emot51.png': '拜神',
      'https://j5.dfcfw.com/imagesystem/emoji/emot52.png': '胜利',
      'https://j5.dfcfw.com/imagesystem/emoji/emot53.png': '赞',
      'https://j5.dfcfw.com/imagesystem/emoji/emot54.png': '握手',
      'https://j5.dfcfw.com/imagesystem/emoji/emot55.png': '抱拳',
      'https://j5.dfcfw.com/imagesystem/emoji/emot56.png': '勾引',
      'https://j5.dfcfw.com/imagesystem/emoji/emot57.png': '拳头',
      'https://j5.dfcfw.com/imagesystem/emoji/emot58.png': 'OKOK',
      'https://j5.dfcfw.com/imagesystem/emoji/emot59.png': '强壮',
      'https://j5.dfcfw.com/imagesystem/emoji/emot60.png': '毛估估',
      'https://j5.dfcfw.com/imagesystem/emoji/emot61.png': '亏大了',
      'https://j5.dfcfw.com/imagesystem/emoji/emot62.png': '赚大了',
      'https://j5.dfcfw.com/imagesystem/emoji/emot63.png': '牛',
      'https://j5.dfcfw.com/imagesystem/emoji/emot65.png': '成交',
      'https://j5.dfcfw.com/imagesystem/emoji/emot66.png': '财力',
      'https://j5.dfcfw.com/imagesystem/emoji/emot67.png': '护城河',
      'https://j5.dfcfw.com/imagesystem/emoji/emot68.png': '复盘',
      'https://j5.dfcfw.com/imagesystem/emoji/emot69.png': '买入',
      'https://j5.dfcfw.com/imagesystem/emoji/emot70.png': '卖出',
      'https://j5.dfcfw.com/imagesystem/emoji/emot71.png': '满仓',
      'https://j5.dfcfw.com/imagesystem/emoji/emot72.png': '空仓',
      'https://j5.dfcfw.com/imagesystem/emoji/emot73.png': '抄底',
      'https://j5.dfcfw.com/imagesystem/emoji/emot74.png': '看多',
      'https://j5.dfcfw.com/imagesystem/emoji/emot75.png': '看空',
      'https://j5.dfcfw.com/imagesystem/emoji/emot76.png': '加仓',
      'https://j5.dfcfw.com/imagesystem/emoji/emot77.png': '减仓',
      'https://j5.dfcfw.com/imagesystem/emoji/emot78.png': '上涨',
      'https://j5.dfcfw.com/imagesystem/emoji/emot79.png': '下跌',
      'https://j5.dfcfw.com/imagesystem/emoji/emot80.png': '财神',
      'https://j5.dfcfw.com/imagesystem/emoji/emot81.png': '火箭',
      'https://j5.dfcfw.com/imagesystem/emoji/emot82.png': '龙头',
      'https://j5.dfcfw.com/imagesystem/emoji/emot83.png': '韭菜',
      'https://j5.dfcfw.com/imagesystem/emoji/emot84.png': '面',
      'https://j5.dfcfw.com/imagesystem/emoji/emot85.png': '泡沫',
      'https://j5.dfcfw.com/imagesystem/emoji/emot86.png': '惨!关灯吃面',
      'https://j5.dfcfw.com/imagesystem/emoji/emot87.png': '666',
      'https://j5.dfcfw.com/imagesystem/emoji/emot88.png': '叹气',
      'https://j5.dfcfw.com/imagesystem/emoji/emot89.png': '让我看看',
      'https://j5.dfcfw.com/imagesystem/emoji/emot90.png': '发财',
      'https://j5.dfcfw.com/imagesystem/emoji/emot91.png': '主力',
      'https://j5.dfcfw.com/imagesystem/emoji/emot92.png': '梭哈',
      'https://j5.dfcfw.com/imagesystem/emoji/emot93.png': '国家队',
      'https://j5.dfcfw.com/imagesystem/emoji/emot94.png': '中签',
      'https://j5.dfcfw.com/imagesystem/emoji/emot95.png': '干杯'
    };
    const data = [...list];
    return data.map((item) => {
      if (typeof item === 'string' && item.match(/\[\D+?\]/)) {
        if(item.slice && typeof item.slice === 'function'){
          const cpItem = item.slice(1, -1);
          const val = this.getKey(cpItem, emojiList);
          if (val) {
            return { emoji: val };
          }
        }
        return item;
      }
      return item;
    });
  }

  // 匹配到对象数组的某个属性值
  keywordType(arr, key, value) {
    const matched = {
      type: Number,
      text: 'no match',
      code: '',
      srcList: '',
    };
    arr.forEach((obj) => {
      if (obj[key] && obj[key] === value) {
        matched.type = obj.Type;
        matched.text = obj.Text;
        matched.code = obj.Code ? obj.Code : '';
        if (obj.Type === 100 && obj.PicImg) {
          const pic = obj.PicImg.match(
            /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g,
          );
          matched.srcList = pic;
        }
      }
    });
    return matched;
  }
  getGGDateFormat(timeString) {
    //发布时间
    //当天 1h内显示[x分钟前],超出1h显示[x小时前]
    //昨天/前天 显示[昨天/前天 23:59]
    //当年 非上述三天 显示[06-12 23:59]
    //非本年 显示[2019-06-12 23:59]

    //显示日期
    // 加点兼容方法
    if (!timeString) {
      return '';
    }
    if (!timeString.replace) {
      return '';
    }
    const date = this.dateFromString(timeString);
    if (!date) return ''
    let resTime = ''
    var year = date.getFullYear();//年
    var month = date.getMonth() + 1;//月    
    var day = date.getDate();//日
    var hours = date.getHours();//时    
    var min = date.getMinutes();//分
    var time = date.getTime();

    //当前日期
    const cDate = new Date();
    var cYear = cDate.getFullYear();
    var cMonth = cDate.getMonth() + 1;
    var cDay = cDate.getDate();
    var cMin = cDate.getMinutes();
    var cTime = cDate.getTime();
    const today = `${cYear}/${this.prefixZero(cMonth)}/${this.prefixZero(cDay)}`;
    const todayTime = new Date(today).getTime();

    //毫秒差
    const num = cTime - time;
    const Zero = (num) => {
      return this.prefixZero(num)
    }
    
    var minGap = num / (1000 * 60);
    var hourGap = minGap / 60;
    var dayGap = hourGap / 24;

    const twentyFourHours = 24 * 60 * 60 *1000;
    const fortyEightHours = 24 * 60 * 60 *1000 * 2;
    const yesterdayTime = new Date(todayTime - twentyFourHours).getTime();
    const lastYesterdayTime = new Date(todayTime - fortyEightHours).getTime();
    // console.log('dayGap '+dayGap+' minGap  '+minGap +' hourGap  '+hourGap);
    if (cYear > year || num < 0) {
      resTime = `${year}-${Zero(month)}-${Zero(day)}`
    } else if (time < lastYesterdayTime) {
      resTime = `${Zero(month)}-${Zero(day)}`
    } else {
      if (time < yesterdayTime && lastYesterdayTime <= time) {
        resTime = `${Zero(month)}-${Zero(day)}`
      } else if (time < todayTime && yesterdayTime <= time) {
        resTime = `昨天`
      } else {
        resTime = "今天";
      }
    }
    if(num < 0){
      resTime = "今天";
    }
    return resTime;
  }
  getDateFormat(publishTime) {
    if (!publishTime) {
      return '';
    }
    if (!publishTime.replace) {
      return '';
    }
    let ptime = publishTime;
    if (publishTime.length > 16) {
      ptime = publishTime.substring(0 , 16);;
    }
    const nowDate = new Date();
    const dateValue = `${nowDate.getFullYear()}/${nowDate.getMonth() + 1}/${nowDate.getDate()} ${nowDate.getHours()}:${nowDate.getMinutes()}`;
    const startTime = publishTime.replace(new RegExp('-', 'gm'), '/');
    const startTimeMiao = (new Date(startTime)).getTime() / 1000; // 得到秒数
    const nowtime = (new Date(dateValue)).getTime() / 1000; // 得到秒数
    const limit = nowtime - startTimeMiao;

    // 计算出相差天数
    const days = Math.floor(limit / (24 * 3600));
    let content = '';
    console.log(`${nowDate.getMonth()}-${nowDate.getDate()}  ${dateValue}`);
    if (days >= 3) {
      content = ptime;
      if (ptime.indexOf) {
        if (ptime.indexOf(nowDate.getFullYear()) !== -1) {
          // 非本年
          content = ptime.substring(5);
        }
      }
      
    } else if (days >= 2 && days < 3) {
      content = `前天 ${ptime.substring(10)}`;
    } else if (days >= 1 && days < 2) {
      content = `昨天 ${ptime.substring(10)}`;
    } else if (limit >= 3600 && limit < 86400) {
      content = `${Math.floor(limit / 3600)}小时前`;
    } else if (limit >= 60 && limit < 3600) {
      content = `${Math.floor(limit / 60)}分钟前`;
    } else {
      content = '刚刚';
    }
    return content;
  }
}
export default new Util();
